import { render } from "./CourseRegistrationModal.vue?vue&type=template&id=15d91922&scoped=true&ts=true"
import script from "./CourseRegistrationModal.vue?vue&type=script&lang=ts"
export * from "./CourseRegistrationModal.vue?vue&type=script&lang=ts"

import "./CourseRegistrationModal.vue?vue&type=style&index=0&id=15d91922&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15d91922"]])

export default __exports__